import { Observable, OperatorFunction } from 'rxjs';
import { map } from 'rxjs/operators';
import { joinObservableWithArrayMultiple } from './joinObservableWithArrayMultiple';

export function mergeObservableWithArrayMultiple<
    InputType,
    OutputType,
    OutputKey extends string = 'output',
    OutputFinalType = OutputType,
    R extends InputType & {
        [key in OutputKey]?: OutputFinalType[];
    } = InputType & {
        [key in OutputKey]?: OutputFinalType[];
    },
>(
    outputArrayMappingFunc: (value: InputType[], index: number) => Observable<OutputType[]> | Promise<OutputType[]>,
    joinFunc: (input: InputType, output: OutputType) => boolean,
    outputKey?: OutputKey,
    outputMappingFunc?: (value: OutputType) => OutputFinalType,
): OperatorFunction<InputType, R> {
    return source$ =>
        source$.pipe(
            joinObservableWithArrayMultiple(outputArrayMappingFunc, joinFunc),
            map(
                ({ input, output }) =>
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    ({
                        ...input,

                        [outputKey ?? 'output']: output && outputMappingFunc ? output.map(outputMappingFunc) : output,
                    } as R),
            ),
        );
}
